module.exports = __webpack_public_path__ + "img/3.c81e2abb.png";